export class ModuleItem {
  svgIcon: string = '';
  title: string = '';
  url: string = '';
  autoLogin?: boolean;
  featureFlag?: string;
}
